"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkMQ5AGG7Cjs = require('./chunk-MQ5AGG7C.js');var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = require('react/jsx-runtime');var r=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.b)`
  position: relative;
  transition: all 200ms ease-in-out;
  max-width: 1000px;
  width: 100%;
  display: inline-block;
  left: 0;
  margin-top: ${e=>e.theme.measurements.spacing(12)};

  &.scrolled {
    font-size: ${e=>e.theme.measurements.spacing(8)};
    font-weight: 600;
    max-width: fit-content;
    margin-top: 0;
    line-height: ${e=>e.theme.measurements.spacing(12)};
    left: ${e=>e.theme.measurements.spacing(8)};
    vertical-align: middle;
  }
`;function s({children:e,className:i,ariaLabel:t,dataTestId:n}){return _jsxruntime.jsx.call(void 0, r,{variant:"h3",ariaLabel:t,dataTestId:n,className:`${i||""} aquilla-dialog-header-heading dialog-header-heading`,children:e})}var p=s;exports.a = s; exports.b = p;
